/** Vista previa del monto de seña (debe coincidir con `resolveDepositCheckoutAmount` en el servidor). */
export function previewDepositAmount(service: {
  requiresDeposit: boolean;
  depositType: string | null | undefined;
  depositAmount: number | null | undefined;
  price: number | null | undefined;
}): number | null {
  if (!service.requiresDeposit) return null;
  const raw = service.depositAmount;
  if (raw == null || raw <= 0) return null;
  const t = service.depositType ?? "fixed";
  if (t === "percentage") {
    if (service.price == null || service.price <= 0) return null;
    const v = Math.round(service.price * (raw / 100) * 100) / 100;
    return v > 0 ? v : null;
  }
  return raw;
}
